<template lang="pug">
  .account
    Main
    Email
    Password
</template>

<script>
import Main from './Account/Main';
import Email from './Account/Email';
import Password from './Account/Password';

export default {
  name: 'Account',
  components: {
    Main,
    Email,
    Password
  }
};
</script>

<style lang="sass" scoped>
.account
  display: grid
  grid-gap: 1rem
  @screen md
    grid-template-rows: auto
    grid-template-columns: 1fr 1fr
    .main
      grid-column: 1 / 3
  @screen lg
    grid-template-rows: auto auto
    grid-template-columns: 3fr 2fr
    .main
      grid-column: 1
      grid-row: 1 / 3
  // @screen xl
  //   grid-template-rows: auto
  //   grid-template-columns: 2fr minmax(300px, 1fr) minmax(300px, 1fr)
  //   .main
  //     grid-column: 1
  //     grid-row: 1

  ::v-deep
    .icon
      @apply flex items-center
      min-height: 3rem
      svg
        width: 3rem
        height: 3rem
      .edit-icon
        display: none
        height: 2.8rem
    .data
      @apply flex flex-col justify-center

    .panel
      min-height: 6.5rem
      display: grid
      grid-gap: 1rem
      transition: box-shadow .05s ease
      @screen md
        grid-template-rows: auto
        grid-template-columns: max-content auto
      &:hover,
      &:focus
        // @apply outline-none
        // @apply outline-black
        // box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.5)
        .default-icon
          display: none
        .edit-icon
          display: block

    .asterisk
      margin: 0 1px
      font-size: .6rem
      display: inline-block
    .password-placeholder
      @apply text-gray-600
      line-height: 1.2rem
    .label
      @apply font-bold
</style>
